import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useAuth from 'hooks/useAuth';
import { fetchJobStates } from 'redux/modules/jobTracker';

/**
 * Load "Viewed" / "Applied" state for the job cards a listing shows.
 * Signed-in users only; ids already loaded are not requested again.
 *
 * @param {{ jobIds: Array<number|string>, ariJobIds: Array<number|string> }} ids
 */
export default function useFetchJobStates({ jobIds, ariJobIds }) {
  const dispatch = useDispatch();
  const { user } = useAuth();
  const userId = user ? user.id : null;
  const key = `${jobIds.join(',')}|${ariJobIds.join(',')}`;

  useEffect(() => {
    if (!userId || key === '|') return;
    dispatch(fetchJobStates({ jobIds, ariJobIds }));
    // `key` stands in for the id arrays, which are rebuilt every render.
  }, [dispatch, userId, key]);
}
